import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PlayerImage } from './PlayerImage';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';

export const JumperNumberCell = ({
    cell,
    cellProps,
    isMainCompetition,
    isAFLW
}) => (
    <th
        {...cellProps}
        className={classNames('stats-table__row-header-cell', {
            'stats-table__cell--sorted': cell.column.isSorted
        })}
    >
        {isMainCompetition && cell?.row?.values?.player?.playerId ? (
            <PlayerProfileLink
                classes="mc-player-stats-table__jumper-number-container stats-table__cell--link js-interchange-bench"
                isAFLW={isAFLW}
                player={{
                    playerId: cell.row.values.player.playerId,
                    firstName: cell?.value?.givenName,
                    surname: cell?.value?.surname
                }}
            >
                <PlayerImage
                    photoURL={cell.value.photoURL}
                    photoName={`${cell?.value?.givenName} ${cell?.value?.surname}`}
                />
                <span
                    className={`mc-player-stats-table__jumper-number mc-player-stats-table__jumper-number--${cell.value.teamLocation} ${cell.value.teamAbbr}`}
                >
                    {cell.value.jumperNumber}
                </span>
            </PlayerProfileLink>
        ) : (
            <div className="mc-player-stats-table__jumper-number-container js-interchange-bench">
                <PlayerImage
                    photoURL={cell.value.photoURL}
                    photoName={`${cell?.value?.givenName} ${cell?.value?.surname}`}
                />
                <span
                    className={`mc-player-stats-table__jumper-number mc-player-stats-table__jumper-number--${cell.value.teamLocation} ${cell.value.teamAbbr}`}
                >
                    {cell.value.jumperNumber}
                </span>
            </div>
        )}
    </th>
);

JumperNumberCell.propTypes = {
    cell: PropTypes.object.isRequired,
    cellProps: PropTypes.object.isRequired,
    isMainCompetition: PropTypes.bool,
    isAFLW: PropTypes.bool
};
